// extracted by mini-css-extract-plugin
module.exports = {"tabCard":"TabCard_tabCard__2Wi0M","tabTitle":"TabCard_tabTitle__3RLk4","tabValue":"TabCard_tabValue__1ZcX7","activeTabCard":"TabCard_activeTabCard__30Q1o"};